// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"353":"contact","594":"about","652":"service"}[chunkId] || chunkId) + "." + {"353":"452d33ca","523":"37f8d99f","594":"c0a6774c","652":"91466c44"}[chunkId] + ".js";
};